import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=691bfe5c&lang=pug&"
import script from "./ClientsTable.vue?vue&type=script&lang=js&"
export * from "./ClientsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports